import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { Radio } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';

import { FieldPropsDispatchers, FieldStateProps, RadioConnectProps } from './types';
import { FieldSet } from './FieldSet';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

const RadioConnect = ({
  label,
  id,
  name,
  modifiers = [],
  autoFocus = false,
  tabIndex = 1,
  disabled = false,
  value,
  required = false,
  dispatchChangeField,
  errors,
  options,
  info,
  screen,
  intl,
  isStringValue,
}: RadioConnectProps & InjectedIntlProps) => {
  return (
    <FieldSet id={id} label={label} required={required} modifiers={modifiers.concat(['light-label', id ?? ''])} errors={errors}>
      <React.Fragment>
        <div className="form-radio__content">
          {options.map((option: { value: any; label: string }, index: number) => (
            <Radio
              key={`${name}-${screen ? `/${screen}` : ''}-${index}`}
              // Adds screen to the name to avoid having two components with the same name
              name={`${name}${screen ? `/${screen}` : ''}`}
              value={option.value.toString()}
              label={intl.formatMessage({ id: option.label, defaultMessage: localeData.en[option.label] })}
              checked={value === option.value}
              onChange={dispatchChangeField}
              data-testid={`form__radio--${id}-${option.value}`}
              autoFocus={autoFocus}
              tabIndex={tabIndex}
              disabled={disabled}
            />
          ))}
        </div>
        {info && (
          <div className="info_small">
            <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
          </div>
        )}
      </React.Fragment>
    </FieldSet>
  );
};

const mapStateToProps = (state: StateType, ownProps: RadioConnectProps): FieldStateProps => ({
  value: state.getIn(ownProps.pathValue),
  errors: state.getIn(ownProps.pathErrors),
});

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: RadioConnectProps): FieldPropsDispatchers => ({
  dispatchChangeField: (_: any, data: any) => {
    // Remove screen from name
    const name = data.name.split('/')[0];

    return dispatch(
      ownProps.onChangeFieldAction({
        value: ownProps.isStringValue ? data.value : data.value === 'true',
        name,
        id: data.id,
      })
    );
  },
});

export default compose<any>(
  connect<FieldStateProps, (dispatch: Dispatch<any>, ownProps: RadioConnectProps) => FieldPropsDispatchers, any, StateType>(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(RadioConnect);
